<template>
  <div id="app">
    <div class="large-screen">
      <header class="index">
        <header-nav active="product"></header-nav>
        <div class="banner single">
          <img class="large-screen-banner" src="images/large/product/banner-cj.jpg">
          <ul class="product-nav">
            <li class="active" data-screen="large" data-type="cj"><img src="images/large/product/cj-active-icon.png"><span>城际专车</span></li>
            <li data-screen="large" data-type="pw"><img src="images/large/product/pw-icon.png"><span>汽车票</span></li>
            <li data-screen="large" data-type="tq"><img src="images/large/product/tq-icon.png"><span>定制通勤</span></li>
          </ul>
        </div>
      </header>
      <section class="product-cj-container cj">
        <div class="line-swiper-wrapper">
          <img src="images/large/product/cj-bg.png">
          <div class="line-container">
            <div class="swiper-container" id="line-swiper-wrapper">
              <div class="swiper-wrapper">

                <div class="swiper-slide">
                  <img src="images/large/product/bus2.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>大邑</span></div>
                    <div class="date-sheet">
                      <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                      <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>1100<sup>+</sup></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus1.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>什邡</span></div>
                    <div class="date-sheet">
                      <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                      <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>800<sup>+</sup></span></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus1.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>金堂</span></div>
                    <div class="date-sheet">
                      <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                      <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>500<sup>+</sup></span></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <img src="images/large/product/bus1.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>彭州</span></div>
                    <div class="date-sheet">
                      <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                      <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>800<sup>+</sup></span></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus3.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>崇州</span></div>
                    <div class="date-sheet">
                      <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2018年</span></div>
                      <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>1300<sup>+</sup></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mark-slide one"></div>
              <!--<div class="mark-slide two"></div>-->
            </div>
            <div class="line-detail-container">
              <div class="title">
                <img src="images/large/product/cj-line-detail-title-icon.png">
                <p>城际专车开行线路</p>
              </div>
              <div class="content">
                <p>天府行现已开通城市：</p>
                <p>成都 、崇州、大邑、绵阳、什邡、三台、射洪 、遂宁、大英、眉山、 丹棱、青神、 金堂、 彭州等。后续会陆续开发更多线路，快速覆盖川内主要城市....</p>
              </div>
            </div>
            <div class="btn-group">
              <div class="line-prev"><img src="images/large/icon/product-prev-active.png"></div>
              <div class="line-next"><img src="images/large/icon/product-next-active.png"></div>
            </div>
          </div>
        </div>
        <div class="line-operation-container">
          <img src="images/large/product/operation-bg.png">
          <div class="line-operation-swiper-wrapper swiper-container" id="line-operation-swiper-wrapper">
            <div class="swiper-wrapper">
              <div class="swiper-slide"><img src="images/large/product/sheet.png"></div>
              <div class="swiper-slide"><img src="images/large/product/car.png"></div>
            </div>
          </div>
          <div class="btn-group">
            <div class="operation-prev"><img src="images/large/icon/prev-active.png"></div>
            <div class="operation-next"><img src="images/large/icon/next-active.png"></div>
          </div>
          <div class="product-sheet-container">
            <div class="sheet-item">
              <img src="images/large/product/market-icon.png">
              <p>市场分析</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <img src="images/large/product/benefit-icon.png">
              <p>效益测算</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <img src="images/large/product/transport-icon.png">
              <p>产品设计</p>
              <p class="small">（运输组织）</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <img src="images/large/product/run-icon.png">
              <p>运行筹备</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <img src="images/large/product/spread-icon.png">
              <p>营销推广</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <img src="images/large/product/online-icon.png">
              <p>上线运行</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <img src="images/large/product/improve-icon.png">
              <p>持续改进</p>
            </div>
          </div>
          <div class="product-sheet-text-container">
            <div class="title">
              <img src="images/large/product/management-title.png">
              <p>线路经营</p>
            </div>
            <div class="content">
              <p>
                经过多条线路开行，天府行在线路开行上已具有完备的方案：在开行前期，由市场部专业调研人员对线路开通城市进行用户调研，为线路的选点/范围、班次、定价等提供依据；确认线路后，由天府行专业人员协助客运企业开行城际线路，提供完整的营销推广方案，并定期提供城际线路经营分析报告，为客运企业提出合理化改进建议。</p>
            </div>
          </div>
        </div>
        <div class="cooperation-divide-container">
          <div class="cooperation-divide-content">
            <div class="cooperation-divide-align">
              <div class="cooperation">
                <p class="title">合作模式</p>
                <p>按城际线路合作</p>
                <p>全面深度业务合作</p>
                <p>紧密的资本性合作</p>
              </div>
              <div class="divide">
                <p class="title">分工协作</p>
                <p>客运企业负责城际线路的日常经营管理</p>
                <p>天府行提供出行平台、运营咨询服务、服务质量规范</p>
              </div>
            </div>
          </div>
          <img src="images/large/product/cooperation.png">
        </div>


      </section>
      <section class="product-item-container product-tq-container tq display-none">
        <div class="content">
          <p class="title">专业运输企业倾力打造</p>
          <ul>
            <li>全新高级客车</li>
            <li>超大座位空间</li>
            <li>睡着上下班</li>
          </ul>
          <img class="icon" src="images/large/product/tq-title-icon.png">
          <img class="illustration" src="images/large/product/tq-illustration.png">
        </div>
        <img class="bg" src="images/large/product/tq-bg.jpg">
        <img class="bg" src="images/large/product/tq-blue-bg.png">
      </section>
      <section class="product-item-container product-pw-container pw display-none">
        <div class="content">
          <p class="title">全新模式</p>
          <ul>
            <li>降低车站人工售票成本</li>
            <li>提高电子票检票效率</li>
            <li>乘客提前规划出行计划</li>
          </ul>
          <img class="icon" src="images/large/product/pw-title-icon.png">
          <img class="illustration" src="images/large/product/pw-illustration.png">
        </div>
        <img class="bg" src="images/large/product/pw-blue-bg.png">
        <img class="bg" src="images/large/product/pw-bg.jpg">
      </section>
      <Footer></Footer>
    </div>

    <div class="small-screen">
      <header-nav-small active="product"></header-nav-small>
      <div class="banner product">
        <img src="images/small/product/banner-cj.jpg">
      </div>
      <section class="small-screen-product-cj-container cj">
        <div class="line-list-container">
          <div class="title">
            <img src="images/small/product/line-list-title-icon.png">
            <p>城际专车开行线路</p>
          </div>
          <div class="small-screen-line-swiper-container">
            <div class="swiper-container" id="small-screen-line-swiper-wrapper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="images/large/product/bus2.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>大邑</span></div>
                    <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                    <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>1100<sup>+</sup></span></div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus1.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>什邡</span></div>
                    <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                    <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>800<sup>+</sup></span></div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus1.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>金堂</span></div>
                    <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                    <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>500<sup>+</sup></span></div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus1.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>彭州</span></div>
                    <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2019年</span></div>
                    <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>800<sup>+</sup></span></div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <img src="images/large/product/bus3.png">
                  <div class="info-detail">
                    <div class="title"><span>成都</span><img src="images/large/product/line-switch-black-icon.png"><span>崇州</span></div>
                    <div class="date"><img src="images/large/product/calendar-icon.png"><span>开行日期</span><span>2018年</span></div>
                    <div class="sheet"><img src="images/large/product/sheet-icon.png"><span>日均客流量</span><span>1300<sup>+</sup></span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="small-screen-line-list-text">
            <p class="title">天府行现已开通城市：</p>
            <p>成都 、崇州、大邑、绵阳、什邡、三台、射洪 、遂宁、大英、眉山、 丹棱、青神、 金堂、 彭州等。后续会陆续开发更多线路，快速覆盖川内主要城市....</p>
          </div>
        </div>
        <div class="line-operation-container">
          <div class="title">
            <img src="images/small/product/management-title.png">
            <p>城际专车开行线路</p>
          </div>
          <div class="product-sheet-container">
            <div class="sheet-item">
              <!--<img src="images/large/product/market-icon.png">-->
              <p>市场分析</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <!--<img src="images/large/product/benefit-icon.png">-->
              <p>效益测算</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <!--<img src="images/large/product/transport-icon.png">-->
              <p>产品设计</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <!--<img src="images/large/product/run-icon.png">-->
              <p>运行筹备</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <!--<img src="images/large/product/spread-icon.png">-->
              <p>营销推广</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <!--<img src="images/large/product/online-icon.png">-->
              <p>上线运行</p>
            </div>
            <div class="triangle-icon"></div>
            <div class="sheet-item">
              <!--<img src="images/large/product/improve-icon.png">-->
              <p>持续改进</p>
            </div>
          </div>
        </div>
        <div class="line-operation-swiper-wrapper swiper-container" id="small-screen-line-operation-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide"><img src="images/large/product/sheet.png"></div>
            <div class="swiper-slide"><img src="images/large/product/car.png"></div>
          </div>
        </div>
        <div class="line-operation-text">
          <p><span>开行前期：</span>由市场部专业调研人员对线路开通城市进行用户调研，为线路的选点/范围、班次、定价等提供依据。</p>
          <p><span>确认线路：</span>由天府行专业人员协助客运企业开行城际线路，提供完整的营销推广方案，并定期提供城际线路经营分析报告，为客运企业提出合理化改进建议。</p>
        </div>
        <div class="cooperation-divide-container">
          <img src="images/large/product/cooperation.png">
          <div class="cooperation-divide-text">
            <ul>
              <li>合作模式</li>
              <li>按城际线路合作</li>
              <li>全面深度业务合作</li>
              <li>紧密的资本性合作</li>
            </ul>
            <ul>
              <li>分工协作</li>
              <li>客运企业负责城际线路的日常经营管理</li>
              <li>天府行提供出行平台、运营咨询服务、服务质量规范</li>
            </ul>
          </div>
        </div>
      </section>

      <section class="small-screen-product-item-container pw display-none">
        <div class="content">
          <p class="title">全新模式</p>
          <ul>
            <li>降低车站人工售票成本</li>
            <li>提高电子票检票效率</li>
            <li>乘客提前规划出行计划</li>
          </ul>
          <img class="icon" src="images/small/product/pw-title-icon.png">
          <img class="illustration" src="images/small/product/pw-illustration.png">
        </div>
      </section>
      <section class="small-screen-product-item-container tq display-none">
        <div class="content">
          <p class="title">专业运输企业倾力打造</p>
          <ul>
            <li>全新高级客车</li>
            <li>超大座位空间</li>
            <li>睡着上下班</li>
          </ul>
          <img class="icon" src="images/small/product/tq-title-icon.png">
          <img class="illustration" src="images/small/product/tq-illustration.png">
        </div>
      </section>


      <ul class="product-nav">
        <li class="active" data-type="cj"><span><img src="images/small/product/cj-icon.png"><span>城际专车</span></span></li>
        <li data-type="pw"><span><img src="images/small/product/pw-icon.png"><span>汽车票</span></span></li>
        <li data-type="tq"><span><img src="images/small/product/tq-icon.png"><span>定制通勤</span></span></li>
      </ul>
    </div>

    <scroll-to-top></scroll-to-top>
  </div>
</template>

<script>
import HeaderNav from "@/components/header-nav";
import HeaderNavSmall from "@/components/header-nav-small";
import Footer from "@/components/footer";
import ScrollToTop from "@/components/scroll-to-top";
import Base64 from "@/utils/base64";
import $ from 'jquery'
import {theRequest} from "@/utils/common";
import Swiper from "swiper";
import 'swiper/css/swiper.min.css'

function f() {
  let url = location.search.substr(1);
  if (url) {
    try {
      let theRequests = theRequest(Base64.decode(url));
      let type = theRequests.type;
      $(".product-nav>li").each(function (index, item) {
        if ($(item).attr('data-type') == type) {
          $(item).addClass('active');
          if ($(item).attr('data-screen') == 'large') {
            $(item).find('img').attr('src', 'images/large/product/' + type + '-active-icon.png');
          }
        } else {
          $(item).removeClass('active');
          if ($(item).attr('data-screen') == 'large') {
            $(item).find('img').attr('src', 'images/large/product/' + type + '-icon.png');
          }
        }
      });
      $('body section').each(function (index, item) {
        if ($(item).hasClass(type)) {
          $(item).removeClass('display-none');
        } else {
          $(item).addClass('display-none');
        }

      });
      if (type) {
        $('.large-screen-banner').attr('src', 'images/large/product/banner-' + type + '.jpg');
        $('.small-screen .banner.product').find('img').attr('src', 'images/small/product/banner-' + type + '.jpg');
      }
    } catch (e) {
      return true;
    }
  }
  $(".product-nav>li").on('click', function () {
    let _this = $(this);
    let type = _this.attr('data-type');
    if (!_this.hasClass('active')) {
      _this.addClass('active').siblings('li').removeClass('active');
      if (_this.attr('data-screen') == 'large') {
        _this.find('img').attr('src', 'images/large/product/' + type + '-active-icon.png');
        _this.parents().siblings('img').attr('src', 'images/large/product/' + type + '-icon.png');
      }
      _this.parents().siblings('img').attr('src', 'images/large/product/banner-' + type + '.jpg');
      $('.small-screen .banner.product').find('img').attr('src', 'images/small/product/banner-' + type + '.jpg');
    }
    $('section.' + type).removeClass('display-none').siblings('section').addClass('display-none')
  });

  if ($('.large-screen').css('display') != 'none') {
    new Swiper('#line-swiper-wrapper', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.line-next',
        prevEl: '.line-prev'
      },
      on: {
        slideChangeTransitionStart: function () {
          // console.log(this.activeIndex);
        },
      }
    });
    new Swiper('#line-operation-swiper-wrapper', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.operation-next',
        prevEl: '.operation-prev'
      }
    });
  } else {
    $('body').css('overflow-x', 'hidden');
    $('.menu-icon').on('click', function () {
      $('.nav-list').removeClass('display-none');
      $('.nav-list>ul').slideToggle('fast');
      $('.nav-logo-close .close, .nav-list').unbind('click').on('click', function () {
        $('.nav-list>ul').slideToggle('fast', function () {
          $('.nav-list').addClass('display-none');
        })
      });
    });

    new Swiper('#small-screen-line-swiper-wrapper', {
      autoplay: {
        delay: 3500,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      loop: true,
      slidesPerView: 'auto',
//                    centeredSlides: true,
      spaceBetween: 20
    });
    new Swiper('#small-screen-line-operation-swiper', {
      autoplay: {
        delay: 3500,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 10
    });
  }
}

export default {
  name: "product",
  components: {ScrollToTop, Footer, HeaderNavSmall, HeaderNav},
  mounted() {
    f()
  }
}
</script>

<style scoped>

</style>